import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { stepPropTypes, stepDefaultProps } from './stepProps';
import Packages from './Packages';
import Pricelist from './Pricelist';

// What the customer gets. One step, where there used to be two.
//
// The old pair -- "Where the prints come from" then "Ways to buy" -- were the
// LEGACY model's questions: pick a Package, then define its Options. For a photo
// package that is a fair description of the thing. For a single print, a download
// or a personalised item it asks about plumbing: there is exactly one item being
// sold, and the package exists only because fulfilment is keyed off it.
//
// So the package question is gone from the default path (PackageBuilder creates one
// on demand, named after the product) and survives only as an Advanced disclosure
// for a photo package that needs to sell from a pricelist that already exists.
const HELP = {
  package: 'A photo package holds several choices a customer picks between — "two 8×10s '
    + 'and eight wallets", say. Add one for each choice.',
  print: 'This product is a single print, so it sells one package: the size the '
    + 'customer receives.',
  digital: 'This product is a download, so it sells one package. Nothing is printed '
    + 'or shipped.',
  printess: 'The customer designs this in the Printess editor, so there are no sheets '
    + 'to choose — just what they are charged for.',
  addon: 'An add-on attaches to something already in the cart rather than being bought '
    + 'on its own.',
};

const Contents = ({
  product, choices, readiness, steps, preview, busy, commit, autosave, reload,
  setOverrides, goTo,
}) => {
  const shared = {
    product,
    choices,
    readiness,
    steps,
    preview,
    busy,
    commit,
    autosave,
    reload,
    setOverrides,
    goTo,
  };
  // Only a photo package has a reason to reuse an existing pricelist: the others
  // are one item, and pointing them at last year's senior package would sell its
  // sheets instead of theirs.
  const offerExisting = product.product_type === 'package';

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        {HELP[product.product_type] || HELP.package}
      </Typography>

      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Packages {...shared} />

      {offerExisting ? (
        <Accordion disableGutters>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" color="text.secondary">
              {product.legacy_package_name
                ? `Advanced — prints come from ${product.legacy_package_name}`
                : 'Advanced — sell from a pricelist that already exists'}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Pricelist {...shared} />
          </AccordionDetails>
        </Accordion>
      ) : null}
    </Stack>
  );
};

Contents.propTypes = stepPropTypes;
Contents.defaultProps = stepDefaultProps;

export default Contents;
